var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BLayoutExpansionTableAsync',_vm._b({attrs:{"value":_vm.list,"loading":_vm.isLoading,"readonly":_vm.readonly,"pagination":_vm.pagination,"title":"Участники","type-table":"collector-participants","name":"participants","return-object":""},on:{"change:pagination":_vm.onChangePagination,"action:download:variants":function (ref) {
	var sha1Sum = ref.sha1_sum;

	return _vm.onDownload(sha1Sum);
},"action:download":function (ref) {
	var criteriaSha1Sum = ref.criteria_sha1_sum;

	return _vm.onDownload(criteriaSha1Sum);
}},scopedSlots:_vm._u([{key:"top",fn:function(){return [_c('BListFilter',{attrs:{"label":"Поиск по имени","skeleton":_vm.isLoading,"dense":""},on:{"change":_vm.onChangeDebounced},model:{value:(_vm.searchForm),callback:function ($$v) {_vm.searchForm=$$v},expression:"searchForm"}})]},proxy:true}])},'BLayoutExpansionTableAsync',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }